

// import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import Header from '../headerFooter/header';
// import HomeFooter from '../homepage/homefooter';
// import './classesandForm.css'; // Unified CSS

// const YogaRegistrationForm = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const { productName, amount, description } = state || { productName: "Yoga Class", amount: 1500 };

//   const [formData, setFormData] = useState({
//     name: '', email: '', phone: '', dob: '', gender: '', timeSlot: '', experience: '', goals: ''
//   });
//   const [errors, setErrors] = useState({});

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Basic Validation Logic here (simplified for brevity)
//     if (!formData.name || !formData.email || !formData.phone) {
//         alert("Please fill in all required fields.");
//         return;
//     }
    
//     navigate('/payment', {
//         state: { yogaRegistrationData: formData, productName, amount, quantity: 1 }
//     });
//   };

//   return (
//     <div className="form-page-wrapper">
//       <Header />
      
//       <form onSubmit={handleSubmit} className="satvic-form">
//         <h2>{productName} Registration</h2>
//         <p className="amount-display">Fee: ₹{amount}</p>
        
//         {description && (
//             <div className="batch-info-box">
//                 <p>{description}</p>
//             </div>
//         )}

//         <div className="form-grid">
//             <div className="full-width">
//                 <label>Full Name *</label>
//                 <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
//             </div>

//             <div>
//                 <label>Email *</label>
//                 <input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
//             </div>

//             <div>
//                 <label>Phone *</label>
//                 <PhoneInput country={'in'} value={formData.phone} onChange={phone => setFormData({...formData, phone})} />
//             </div>

//             <div>
//                 <label>Date of Birth *</label>
//                 <input type="date" name="dob" value={formData.dob} onChange={handleInputChange} max={new Date().toISOString().split("T")[0]} required />
//             </div>

//             <div>
//                 <label>Gender *</label>
//                 <select name="gender" value={formData.gender} onChange={handleInputChange} required>
//                     <option value="">Select</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                 </select>
//             </div>

//             <div className="full-width">
//                 <label>Select Time Slot *</label>
//                 <div className="selection-group">
//                     <label><input type="radio" name="timeSlot" value="Morning" onChange={handleInputChange} /> Morning </label>
//                     <label><input type="radio" name="timeSlot" value="Evening" onChange={handleInputChange} /> Evening </label>
//                 </div>
//             </div>

//             <div className="full-width">
//                 <label>Experience Level *</label>
//                 <div className="selection-group">
//                     <label><input type="radio" name="experience" value="Beginner" onChange={handleInputChange} /> Beginner</label>
//                     <label><input type="radio" name="experience" value="Intermediate" onChange={handleInputChange} /> Intermediate</label>
//                     <label><input type="radio" name="experience" value="Advanced" onChange={handleInputChange} /> Advanced</label>
//                 </div>
//             </div>

//             <div className="full-width">
//                 <label>Your Goals</label>
//                 <textarea name="goals" rows="3" value={formData.goals} onChange={handleInputChange} placeholder="What do you hope to achieve?"></textarea>
//             </div>
//         </div>

//         <button type="submit" className="submit-btn">Proceed to Payment</button>
//       </form>

//       <HomeFooter />
//     </div>
//   );
// };

// export default YogaRegistrationForm;


// import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import Header from '../headerFooter/header';
// import HomeFooter from '../homepage/homefooter';
// import './classesandForm.css';

// const YogaRegistrationForm = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const { productName, amount, description } =
//     state || { productName: 'Yoga Class', amount: 1500 };

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     dob: '',
//     gender: '',
//     timeSlot: '',
//     experience: '',
//     goals: '',
//   });

//   const [consent, setConsent] = useState(false);
//   const [errors, setErrors] = useState({});

//   const handleInputChange = e => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = e => {
//     e.preventDefault();

//     if (!formData.name || !formData.email || !formData.phone) {
//       alert('Please fill in all required fields.');
//       return;
//     }

//     if (!consent) {
//       setErrors({ consent: true });
//       return;
//     }

//     navigate('/payment', {
//       state: {
//         yogaRegistrationData: formData,
//         productName,
//         amount,
//         quantity: 1,
//       },
//     });
//   };

//   return (
//     <div className="form-page-wrapper">
//       <Header />

//       <form onSubmit={handleSubmit} className="satvic-form">
//         <h2>{productName} Registration</h2>
//         <p className="amount-display">Fee: ₹{amount}</p>

//         {description && (
//           <div className="batch-info-box">
//             <p>{description}</p>
//           </div>
//         )}

//         <div className="form-grid">
//           <div className="full-width">
//             <label>Full Name *</label>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleInputChange}
//               required
//             />
//           </div>

//           <div>
//             <label>Email *</label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleInputChange}
//               required
//             />
//           </div>

//           <div>
//             <label>Phone *</label>
//             <PhoneInput
//               country="in"
//               value={formData.phone}
//               onChange={phone =>
//                 setFormData(prev => ({ ...prev, phone }))
//               }
//             />
//           </div>

//           <div>
//             <label>Date of Birth *</label>
//             <input
//               type="date"
//               name="dob"
//               value={formData.dob}
//               onChange={handleInputChange}
//               max={new Date().toISOString().split('T')[0]}
//               required
//             />
//           </div>

//           <div>
//             <label>Gender *</label>
//             <select
//               name="gender"
//               value={formData.gender}
//               onChange={handleInputChange}
//               required
//             >
//               <option value="">Select</option>
//               <option value="Male">Male</option>
//               <option value="Female">Female</option>
//             </select>
//           </div>

//           <div className="full-width">
//             <label>Select Time Slot *</label>
//             <div className="selection-group">
//               <label>
//                 <input
//                   type="radio"
//                   name="timeSlot"
//                   value="Morning"
//                   onChange={handleInputChange}
//                 />{' '}
//                 Morning
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   name="timeSlot"
//                   value="Evening"
//                   onChange={handleInputChange}
//                 />{' '}
//                 Evening
//               </label>
//             </div>
//           </div>

//           <div className="full-width">
//             <label>Experience Level *</label>
//             <div className="selection-group">
//               <label>
//                 <input
//                   type="radio"
//                   name="experience"
//                   value="Beginner"
//                   onChange={handleInputChange}
//                 />{' '}
//                 Beginner
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   name="experience"
//                   value="Intermediate"
//                   onChange={handleInputChange}
//                 />{' '}
//                 Intermediate
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   name="experience"
//                   value="Advanced"
//                   onChange={handleInputChange}
//                 />{' '}
//                 Advanced
//               </label>
//             </div>
//           </div>

//           <div className="full-width">
//             <label>Your Goals</label>
//             <textarea
//               name="goals"
//               rows="3"
//               value={formData.goals}
//               onChange={handleInputChange}
//               placeholder="What do you hope to achieve?"
//             />
//           </div>
//         </div>

//         {/* ✅ CONSENT (MANDATORY) */}
//         <div className="full-width consent-box">
//           <label className="consent-label">
//             <input
//               type="checkbox"
//               checked={consent}
//               onChange={e => {
//                 setConsent(e.target.checked);
//                 setErrors({});
//               }}
//             />
//             <span>
//               I agree to the{' '}
//               <a
//                 href="http://localhost:3000/t&c"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Terms & Conditions
//               </a>{' '}
//               and{' '}
//               <a
//                 href="http://localhost:3000/privacy"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Privacy Policy
//               </a>
//             </span>
//           </label>

//           {errors.consent && (
//             <p className="error-message">
//               You must agree before proceeding
//             </p>
//           )}
//         </div>

//         <button
//           type="submit"
//           className="submit-btn"
//           disabled={!consent}
//         >
//           Proceed to Payment
//         </button>
//       </form>

//       <HomeFooter />
//     </div>
//   );
// };

// export default YogaRegistrationForm;
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import './classesandForm.css';
import API from '../api'; 

/* ---------------- Skeleton Loader ---------------- */
const FormSkeleton = () => (
  <div className="form-page-wrapper">
    <Header />
    <div className="satvic-form" style={{ opacity: 0.7 }}>
      {/* Skeleton Title & Price */}
      <div style={{ height: '32px', background: '#eaeaea', borderRadius: '4px', width: '60%', margin: '0 auto 15px auto' }} />
      <div style={{ height: '20px', background: '#eaeaea', borderRadius: '4px', width: '40%', margin: '0 auto 30px auto' }} />

      {/* Skeleton Input Grid */}
      <div className="form-grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} style={{ width: '100%' }}>
            <div style={{ height: '16px', background: '#eaeaea', borderRadius: '4px', width: '40%', marginBottom: '8px' }} />
            <div style={{ height: '45px', background: '#eaeaea', borderRadius: '4px', width: '100%' }} />
          </div>
        ))}
      </div>

      {/* Skeleton Consent & Button */}
      <div style={{ height: '20px', background: '#eaeaea', borderRadius: '4px', width: '80%', margin: '30px 0 20px 0' }} />
      <div style={{ height: '50px', background: '#eaeaea', borderRadius: '4px', width: '100%' }} />
    </div>
    <HomeFooter />
  </div>
);
const YogaLoader = () => (
  <div className="form-page-wrapper">
    <Header />
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '60vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      {/* Replace this src with the path to your actual GIF */}
      <img 
        src="https://assets-v2.lottiefiles.com/a/ced29b74-1166-11ee-b704-bb55d6385ad8/hIFkLjJoho.gif" 
        alt="Loading..." 
        style={{ 
          width: '240px', 
          height: '240px', 
          marginBottom: '20px',
          borderRadius: '50%' // Optional: makes it circular if it has a background
        }} 
      />
      <h3 style={{ color: '#4A5568', fontWeight: '500' }}>
        Preparing your form...
      </h3>
    </div>
    <HomeFooter />
  </div>
);
const YogaRegistrationForm = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const classId = searchParams.get('classId');

  const [item, setItem] = useState(
    state?.productName && state?.amount
      ? { title: state.productName, price: state.amount, description: state.description }
      : null
  );

  const [fetchError, setFetchError] = useState(false);
  const [consent, setConsent] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', dob: '', gender: '', timeSlot: '', experience: '', goals: '',
  });

  useEffect(() => {
    if (item) return;
    if (!classId) {
      setFetchError(true);
      return;
    }

    // const fetchClass = async () => {
    //   try {
    //     const apiUrl = process.env.REACT_APP_API_URL || '';
    //     const res = await fetch(`${apiUrl}/api/classes`);
    //     if (!res.ok) throw new Error('Failed to fetch classes');

    //     const data = await res.json();
    //     const specificClass = data.find(cls => String(cls.id) === String(classId));

    //     if (!specificClass) throw new Error('Class not found');

    //     setItem({
    //       title: specificClass.title,
    //       price: specificClass.price,
    //       description: specificClass.description,
    //     });
    //   } catch (err) {
    //     console.error("Direct link fetch error:", err);
    //     setFetchError(true);
    //   }
    // };
  const fetchClass = async () => {
      try {
        // Use your pre-configured API helper instead of raw fetch
        const res = await API.get('/api/classes'); 
        
        // Axios stores the JSON in res.data
        const data = res.data; 

        // Find the specific class
        const specificClass = data.find(cls => String(cls.id) === String(classId));

        if (!specificClass) throw new Error('Class not found');

        setItem({
          title: specificClass.title,
          price: specificClass.price,
          description: specificClass.description,
        });
      } catch (err) {
        console.error("Direct link fetch error:", err);
        setFetchError(true);
      }
    };
    fetchClass();
  }, [item, classId]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!item) return;

    if (!formData.name || !formData.email || !formData.phone) {
      alert('Please fill in all required fields.');
      return;
    }

    if (!consent) {
      setErrors({ consent: true });
      return;
    }

    navigate('/payment', {
      state: {
        formType: 'Yoga', // Added formType to match your server.js logic
        yogaRegistrationData: formData,
        productName: item.title,
        amount: item.price,
        quantity: 1,
      },
    });
  };

  if (fetchError) {
    return (
      <div className="form-page-wrapper">
        <Header />
        <div style={{ textAlign: 'center', padding: '100px 20px' }}>
          <h2>Class Not Found</h2>
          <p>We couldn't load the details for this program.</p>
          <button className="submit-btn" onClick={() => navigate('/classes')} style={{ maxWidth: '200px', marginTop: '20px' }}>
            Browse All Classes
          </button>
        </div>
        <HomeFooter />
      </div>
    );
  }
if (!item) return <YogaLoader />; 
  // if (!item) return <p style={{ textAlign: 'center', marginTop: '100px' }}>Loading...</p>;
// if (!item) return <FormSkeleton />;

  return (
    <div className="form-page-wrapper">
      <Header />
      <form onSubmit={handleSubmit} className="satvic-form">
        <h2>{item.title} Registration</h2>
        <p className="amount-display">Fee: ₹{item.price}</p>
        {item.description && <div className="batch-info-box"><p>{item.description}</p></div>}
        
        <div className="form-grid">
          <div className="full-width"><label>Full Name *</label><input type="text" name="name" value={formData.name} onChange={handleInputChange} required /></div>
          <div><label>Email *</label><input type="email" name="email" value={formData.email} onChange={handleInputChange} required /></div>
          <div><label>Phone *</label><PhoneInput country="in" value={formData.phone} onChange={phone => setFormData(prev => ({ ...prev, phone }))} /></div>
          <div><label>Date of Birth *</label><input type="date" name="dob" value={formData.dob} onChange={handleInputChange} max={new Date().toISOString().split('T')[0]} required /></div>
          <div><label>Gender *</label><select name="gender" value={formData.gender} onChange={handleInputChange} required><option value="">Select</option><option value="Male">Male</option><option value="Female">Female</option></select></div>
          <div className="full-width"><label>Select Time Slot *</label>
            <div className="selection-group">
              <label><input type="radio" name="timeSlot" value="Morning" onChange={handleInputChange} /> Morning</label>
              <label><input type="radio" name="timeSlot" value="Evening" onChange={handleInputChange} /> Evening</label>
            </div>
          </div>
          <div className="full-width"><label>Experience Level *</label>
            <div className="selection-group">
              <label><input type="radio" name="experience" value="Beginner" onChange={handleInputChange} /> Beginner</label>
              <label><input type="radio" name="experience" value="Intermediate" onChange={handleInputChange} /> Intermediate</label>
              <label><input type="radio" name="experience" value="Advanced" onChange={handleInputChange} /> Advanced</label>
            </div>
          </div>
          <div className="full-width"><label>Your Goals</label><textarea name="goals" rows="3" value={formData.goals} onChange={handleInputChange} placeholder="What do you hope to achieve?" /></div>
        </div>

        <div className="full-width consent-box">
          <label className="consent-label">
            <input type="checkbox" checked={consent} onChange={e => { setConsent(e.target.checked); setErrors({}); }} />
            <span>I agree to the <a href="/t&c" target="_blank" rel="noopener noreferrer">Terms & Conditions</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></span>
          </label>
          {errors.consent && <p className="error-message">You must agree before proceeding</p>}
        </div>

        <button type="submit" className="submit-btn" disabled={!consent}>Proceed to Payment</button>
      </form>
      <HomeFooter />
    </div>
  );
};

export default YogaRegistrationForm;